module.exports = __webpack_public_path__ + "static/media/button-checked.b7b9483d.svg";